// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__wFN97","colMaxWidth":"Table_colMaxWidth__O8rFN"};